import {post} from "../utils";
import {makeJsonData} from "./utils";

export default host => ({
    name,
    visibility,
    type,
    email,
    detail,
    client,
    googleAnalyticsId,
    googleTagManagerId,
    customUrl,
    channelContentCreatorTypes,
    translations,
    catalogs,
    socialLinks,
    imageId,
    loginImageId,
    faviconId,
    showBanner,
    showAdvancedSearch,
    showTagsSearch,
    showSupport,
    links,
    showAbout,
    tags,
    navbarElements,
    binaryId,
    policyId,
    bloomcloudChannel,
    loginType,
    language,
    canDownloadTracks,
    keywordsSEO,
    descriptionSEO,
    tagGroups,
    supportNegativeSearch,
    trackingGroup,
    showLoginButton,
    preRollVideoId,
    }) => {
  return post(`${host}/channels`,
    makeJsonData({
        name,
        visibility,
        type,
        email,
        detail,
        client,
        googleAnalyticsId,
        googleTagManagerId,
        customUrl,
        channelContentCreatorTypes,
        translations,
        catalogs,
        socialLinks,
        imageId,
        loginImageId,
        faviconId,
        showBanner,
        showAdvancedSearch,
        showTagsSearch,
        showSupport,
        links,
        showAbout,
        tags,
        navbarElements,
        binaryId,
        policyId,
        bloomcloudChannel,
        loginType,
        language,
        canDownloadTracks,
        keywordsSEO,
        descriptionSEO,
        tagGroups,
        supportNegativeSearch,
        trackingGroup,
        showLoginButton,
        preRollVideoId,
    })
  )
    .then(response => response.json())
    .then(response => response.data)
}